_ = require('lodash')
moment = require('moment')

GroupInfoEventsCtrl = ( $scope ,$translate ,$filter , $location ,groupEventService ) ->
  infoEventsCtrl = this
  pageSize = 4
  currentPage = 1
  infoEventsCtrl.lsEvents = []
  infoEventsCtrl.isLoading = false

  infoEventsCtrl.displayPeriod = (startTime, endTime) ->
    reText = ""
    if !startTime && !endTime
      return reText
    reText = $filter('translate')('_GROUP_EVENT.PERIOD_NAME')
    reText += ": "
    reText += infoEventsCtrl.displayDateByLang(startTime)
    reText += "~"
    reText += infoEventsCtrl.displayDateByLang(endTime)
    reText

  infoEventsCtrl.displayDateByLang = (time) ->
    if !time
      return ""
    d = moment(time)
    formatText = 'YYYY-MM-DD(ddd)'
    if /^ja/i.test $translate.preferredLanguage()
      formatText = 'LL(ddd)'
      moment.locale('ja')
    d.format(formatText)

  infoEventsCtrl.displayParticipants = (number) ->
    reText = $filter('translate')('_GROUP_EVENT.PARTICIPANTS')
    reText += ': '
    reText += number
    if /^ja/i.test $translate.preferredLanguage()
      reText += '人'
    reText

  infoEventsCtrl.displayNoParticipants = (number) ->
    reText = $filter('translate')('_GROUP_EVENT.NONPARTICIPANTS')
    reText += ': '
    reText += number
    if /^ja/i.test $translate.preferredLanguage()
      reText += '人'
    reText

  infoEventsCtrl.gotoRankTab = ->
    url = "/groups/"+ $scope.groupInfo.id + "#rank"
    $location.url(url)

  $scope.gotoEventRank = (id) ->
    url = "/group-event/"+ id + "/ranking"
    $location.url(url)



  loadEvents = ->
    params =
      id : $scope.groupInfo.id
      page : currentPage
      page_size : pageSize
    groupEventService.listEvent(params)
    .then (data) ->
      infoEventsCtrl.lsEvents = _.union( infoEventsCtrl.lsEvents, data.events)
    .finally ->
      infoEventsCtrl.isLoading = false

  loadEvents()
  infoEventsCtrl

GroupInfoEventsCtrl.$inject = [
  '$scope'
  '$translate'
  '$filter'
  '$location'
  'groupEventService'
]

module.exports = GroupInfoEventsCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-info/group-info-events-controller.coffee